// extracted by mini-css-extract-plugin
export default {"name":"_1A57KenwyL4pP0M4E5KpJj","duration":"_1WCcirdRlbZobMPVl4kh5V","capacity":"_3plLlMRx6G6vadRdMVmR6J","pricing":"_3LWIYBONAFXrdhbB924wWw"};